var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.75 70.5V74.4167C82.75 78.725 79.225 82.25 74.9167 82.25H20.0833C18.0058 82.25 16.0134 81.4247 14.5443 79.9557C13.0753 78.4866 12.25 76.4942 12.25 74.4167V19.5833C12.25 17.5058 13.0753 15.5134 14.5443 14.0443C16.0134 12.5753 18.0058 11.75 20.0833 11.75H74.9167C79.225 11.75 82.75 15.275 82.75 19.5833V23.5H47.5C45.4225 23.5 43.43 24.3253 41.961 25.7943C40.492 27.2634 39.6667 29.2558 39.6667 31.3333V62.6667C39.6667 64.7442 40.492 66.7366 41.961 68.2057C43.43 69.6747 45.4225 70.5 47.5 70.5H82.75ZM47.5 62.6667H86.6667V31.3333H47.5V62.6667ZM63.1667 52.875C59.9158 52.875 57.2917 50.2508 57.2917 47C57.2917 43.7492 59.9158 41.125 63.1667 41.125C66.4175 41.125 69.0417 43.7492 69.0417 47C69.0417 50.2508 66.4175 52.875 63.1667 52.875Z",
    fill: "url(#paint0_linear_204_427)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_427",
    x1: 49.4583,
    y1: 11.75,
    x2: 49.4583,
    y2: 82.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWallet);
export default __webpack_public_path__ + "static/media/green-wallet.9decc3b02cc48dc0718231bba5e2fc8a.svg";
export { ForwardRef as ReactComponent };